import { render, staticRenderFns } from "./DynamicFormModal.vue?vue&type=template&id=2782afbe"
import script from "./DynamicFormModal.vue?vue&type=script&lang=js"
export * from "./DynamicFormModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormModal.vue?vue&type=style&index=0&id=2782afbe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports